import { Component } from '@angular/core';

@Component({
  selector: 'app-relatorios-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})

export class RelatoriosClientesComponent {}
